export default { sha: '00dc3f2cf89f7397755cbc5121508be7390fed62', buildNumber: 'undefined' }
